import { NonEmptyArray } from "ts-essentials"

export function descriptorValidator(values: NonEmptyArray<unknown>) {
  return !!values[0]
}
